import { SelectSnapshot } from 'components/SelectSnapshot/SelectSnapshot';
import { useLocale } from 'containers/App/LocaleContext';
import { changeSnapshot } from 'pages/SnapshotManagement/actions';
import { useSnapshots } from 'pages/SnapshotManagement/useSnapshots';
import { memo } from 'react';
import type { FC } from 'react';
import { useDispatch } from 'react-redux';
import { useSnapshotId } from 'utils/hooks/useSnapshotId';

const BareSidebarSnapshots: FC = () => {
  const sidebarMsg = useLocale().app.sidebar;
  const snapshots = useSnapshots();
  const selectedSnapshotId = useSnapshotId();
  const dispatch = useDispatch();

  return (
    <div className='mx-4 mt-6'>
      <span className='sidebar__actions-snapshot-title'>
        {sidebarMsg.menuText.snapshots}
      </span>
      <SelectSnapshot
        placeholder={
          snapshots.length === 0
            ? sidebarMsg.menuText.snapshotPlaceholderNoSnapshotLoaded
            : undefined
        }
        snapshots={snapshots}
        value={selectedSnapshotId}
        onChange={(snapshot) => dispatch(changeSnapshot(snapshot))}
      />
    </div>
  );
};

export const SidebarSnapshots = memo(BareSidebarSnapshots);
